<template>
  <v-layout v-if="active" row justify-center>
    <v-dialog
      :value="active"
      max-width="40%"
      @click:outside="
        () => {
          cancel()
        }
      "
    >
      <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text v-if="message">{{ message }}</v-card-text>

        <v-checkbox v-if="textCheckbox.length" class="ml-5" v-model="reset" :label="textCheckbox"></v-checkbox>
        <v-card-actions class="d-flex justify-space-between">
          <div>
            <v-btn class="ma-2" outlined dark color="#0D47A1" @click.native="cancel">{{ cancelText }}</v-btn>
          </div>
          <div>
            <v-btn
              v-if="ok2Text.length"
              class="ma-2"
              outlined
              dark
              color="#0D47A1"
              @click.native="() => confirm('option2')"
              >{{ ok2Text }}</v-btn
            >
            <v-btn
              v-if="ok1Text.length"
              class="ma-2"
              dark
              depressed
              color="#0D47A1"
              @click.native="() => confirm('option1')"
              >{{ ok1Text }}</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    title: '',
    message: '',
    ok1Text: '',
    ok2Text: '',
    cancelText: 'Hủy',
    textCheckbox: '',
    active: false,
    resolver: null,
    data: {},
    reset: false
  }),
  methods: {
    show({ data = {}, title, message, ok1Text = '', ok2Text = '', cancelText = '', textCheckbox = '' }) {
      this.reset = false
      this.data = data
      this.textCheckbox = textCheckbox
      this.title = title
      this.message = message
      this.ok1Text = ok1Text
      this.ok2Text = ok2Text
      this.cancelText = cancelText
      this.active = true
    },
    confirm(emit) {
      this.active = false
      this.$emit(emit, { ...this.data, reset: this.reset })
    },
    cancel() {
      this.active = false
      this.$emit('cancel')
    }
  }
}
</script>

<style></style>
